import { takeEvery, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
// actions
import { VALIDATE_TOKEN, SIGN_IN, SET_SUBSCRIPTION } from '../reducers/auth';

// utils
import { clearAuthData } from '../../utils/authData';
import { getProgram } from '../reducers/program';
import { openModal } from '../reducers/modal';
import { shouldShowDailyModal } from '../../containers/DailyCheckIn/utils';
import { shouldShowRiskModal } from '../../containers/WeeklyCheckIn/utils';
import { shouldShowSatisfactionModal } from '../../containers/MonthlyCheckIn/utils';
import { shouldShowBillingModal } from '../../containers/Billing/utils';

/* worker */
function onTokenError({ payload: { status } }) {
  if (status === 401) {
    clearAuthData();
  }
}

function* onTokenSuccess({ payload: { resource } }) {
  const shouldFetchProgram =
    resource.role === 'support' || resource.progress.module !== 0;

  if (shouldFetchProgram && resource.progress.subscription) {
    yield put(getProgram());
  }

  yield openModals(resource);
}

function* onSetSubscription() {
  const user = yield select(state => state.auth.user);
  const redirect = 'dashboard';
  yield put(push(redirect));
  yield openModals(user);
}

function* openModals(user) {
  if (shouldShowBillingModal(user)) {
    // yield put(openModal('BILLING'));
  }

  if (shouldShowDailyModal(user)) {
    yield put(
      openModal('CHECK_IN', {
        type: 'daily',
      })
    );
  }

  if (shouldShowRiskModal(user)) {
    yield put(
      openModal('CHECK_IN', {
        type: 'weekly',
      })
    );
  }

  if (shouldShowSatisfactionModal(user)) {
    yield put(
      openModal('CHECK_IN', {
        type: 'monthly',
      })
    );
  }
}

/* watcher */
function* watchTokenActions() {
  yield takeEvery(`${VALIDATE_TOKEN}_ERROR`, onTokenError);
  yield takeEvery(`${VALIDATE_TOKEN}_SUCCESS`, onTokenSuccess);
  yield takeEvery(`${SIGN_IN}_SUCCESS`, onTokenSuccess);
  yield takeEvery(SET_SUBSCRIPTION, onSetSubscription);
}

export default watchTokenActions;



// WEBPACK FOOTER //
// ./src/redux/sagas/auth.js